import { render, staticRenderFns } from "./BjzxList.vue?vue&type=template&id=2e3ecea8&scoped=true"
import script from "./BjzxList.vue?vue&type=script&lang=js"
export * from "./BjzxList.vue?vue&type=script&lang=js"
import style0 from "./BjzxList.vue?vue&type=style&index=0&id=2e3ecea8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3ecea8",
  null
  
)

export default component.exports